import { useMutation } from '@tanstack/react-query';

export function useCreateContentRegisterFileGenerationProcessMutation() {
  return useMutation({
    mutationFn: async ({ masterActivityIds }) => {
      const response = await axios.post(
        '/content_register/file_generation_processes',
        {
          file_generation_process: {
            master_activities: masterActivityIds.map((id, index) => ({
              id,
              selected_order: index,
            })),
          },
        },
      );
      return response.data;
    },
  });
}
